import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-preview-logo',
  templateUrl: './preview-logo.component.html',
  styleUrls: ['./preview-logo.component.scss']
})
export class PreviewLogoComponent {
  @Input() logo: string | ArrayBuffer;
  @Input() detail = {
    name_th: '',
    name_en: '',
    tax_id: '',
    address_th: '',
    address_en: '',
    post_code: ''
  };

  constructor() { }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/preview-logo/preview-logo.component.ts